import { render, staticRenderFns } from "./AlugueisAtrasados.vue?vue&type=template&id=199fbf50&"
import script from "./alugueisAtrasados.js?vue&type=script&lang=js&"
export * from "./alugueisAtrasados.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports